<template>
  <div class="ec-collapse">
    <!-- Trigger (shown when title is provided or trigger slot is used) -->
    <div
      v-if="title || $slots.trigger"
      class="ec-collapse-trigger"
      role="button"
      tabindex="0"
      @click="toggle"
      @keydown.enter.prevent="toggle"
      @keydown.space.prevent="toggle"
    >
      <slot name="trigger">
        <span class="ec-collapse-title">{{ title }}</span>
      </slot>
      <svg
        class="ec-collapse-chevron"
        :class="{ 'ec-collapse-chevron--open': computedOpen }"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
      >
        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
      </svg>
    </div>

    <!-- Content -->
    <transition name="ec-collapse">
      <div v-show="computedOpen" class="ec-collapse-content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'EcCollapse',

  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: { default: undefined },
    modelValue: { default: undefined },
    open: { default: undefined },
    title: { type: String, default: '' },
  },

  data() {
    return {
      internalOpen: false,
    }
  },

  computed: {
    computedOpen() {
      if (this.value !== undefined) return !!this.value
      if (this.modelValue !== undefined) return !!this.modelValue
      if (this.open !== undefined) return !!this.open
      return this.internalOpen
    },
  },

  methods: {
    toggle() {
      if (this.value !== undefined) {
        this.$emit('input', !this.value)
      } else if (this.modelValue !== undefined) {
        this.$emit('update:modelValue', !this.modelValue)
      } else if (this.open !== undefined) {
        this.$emit('update:open', !this.open)
      } else {
        this.internalOpen = !this.internalOpen
      }
    },
  },
}
</script>
